module.exports = __webpack_public_path__ + "media/images/register_image2-4b6a541c386cbdc5a8efb8b93b0e4914.png";